import { getEnvironment } from '@ubi/js-utils/environment'
import { createLogger } from '@ubi/js-utils/logger'
import {
    initDatadog,
    transportHandler as datadogTransport,
    actionsHandler as datadogActionsHandler,
} from './datadog'

const getOptions = () => {
    const name = 'configuration-app'
    if (getEnvironment() !== 'LOCAL') {
        return {
            name,
            transport: {
                initialize: initDatadog,
                reporter: datadogTransport,
                actionsReporter: datadogActionsHandler,
            },
        }
    }
    return {
        name,
    }
}

export const logger = createLogger(getOptions())
